import { htmlToText } from "html-to-text"

export function isEmailOrDomain(value = "") {
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(`domaincheck${value}`)
    if (isValid) {
        return
    }
    throw new Error("Must be an email address or an email @ domain")
}

export function htmlStringTrimRequired(value = "") {
    const isValid = !!htmlToText(value).trim()
    if (isValid) {
        return
    }
    throw new Error("Is a required field")
}
